import { saveAs } from 'file-saver';
import { utils, write } from 'xlsx';

import { formatConfigToMap } from '../helpers';
import { ConfigOrderDetails } from '../types';

function exportOrderDetailsToExcel(config: ConfigOrderDetails) {
  const data = formatConfigToMap(config);
  const worksheet = utils.json_to_sheet(data);
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  const excelBuffer = write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(blob, `${config.header.name ?? 'file_1'}.xlsx`);
}

export default exportOrderDetailsToExcel;
